import ApiService from '@services/api.service';
import { Notify}  from 'quasar';

export const coordonneeUrgence = {
  state:  {
    coordonneeUrgences: [],
    coordonneeUrgence: null
  },
  mutations: {
    setCoordonneeUrgences(state, coordonneeUrgences){
      state.coordonneeUrgences = coordonneeUrgences;
    },
    setCoordonneeUrgence(state, coordonneeUrgence){
      state.coordonneeUrgence = coordonneeUrgence;
    },
  },
  actions: {
    async fetchCoordonneeUrgenceByEtudiant(context, idStagiaire){
      return await ApiService.getRequest(`/etudiant_coordonee_urgences_etudiant/${idStagiaire}`)
        .then((response) => {
          context.commit('setCoordonneeUrgences', response.data)
          return response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchCoordonneeUrgence (context, coordonnee){
      try{
        console.log('coordonnees', coordonnee)
        const response =  ApiService.getRequest(coordonnee);
        console.log("response", response);
        context.commit('setCoordonneeUrgence', response.data);
        return response.data;
      }catch(error){
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red',
        })
      }
    }
  },
  getters: {
    getCoordonneeUrgences(state){
      return state.coordonneeUrgences;
    },
    getCoordonneeUrgence(state){
      return state.coordonneeUrgence;
    },
  }
}
